import React from 'react';
import { Card, CardTitle, CardText } from 'reactstrap';

const ComingSoon = (props) => {

  var articleCardStyle = {
    maxWidth:320,
    minWidth:300,
    marginBottom: 10
  };

  var titleStyle = {
    fontFamily: "Audiowide, cursive",
    color: "cadetblue"
  }

  return (
    <React.Fragment>
        <Card body style={articleCardStyle}>
          <CardTitle style={titleStyle}>Okku #1</CardTitle>
          <CardText>Congrats to Okku, Rank 1 on the May Leaderboard!</CardText>
        </Card>

        <Card body style={articleCardStyle}>
          <CardTitle style={titleStyle}>Friday Night Champ 10</CardTitle>
          <CardText>
          <ol>
          <li>Okku</li>
          <li>Niboshi</li>
          <li>Firemonster</li>
          </ol>
          </CardText>
        </Card>

        <Card body style={articleCardStyle}>
          <CardTitle style={titleStyle}>Japan Daytime Nova 3</CardTitle>
          <CardText>
          <ol>
          <li>Tanashu</li>
          <li>AAAAAFather</li>
          <li>Pack</li>
          </ol>
          </CardText>
        </Card>

        <Card body style={articleCardStyle}>
          <CardTitle style={titleStyle}>Next Tournament</CardTitle>
          <CardText>Join us Friday June 22nd, sign up on the Tournaments page!</CardText>
        </Card>


    </React.Fragment>
  );
};

export default ComingSoon;


/*

<Card>
  <CardBody>
    <CardTitle style={titleStyle}>Nature Control</CardTitle>
    <CardSubtitle>By: Psynight</CardSubtitle>
  </CardBody>
  <img width="100%" src="../ArticleImages/DeckCardTest.png" alt="Card image cap" />
  <CardBody>
    <CardText>10 Upvotes - Updated 3/6/2018</CardText>
  </CardBody>
</Card>


*/



// WEBPACK FOOTER //
// ./src/Articles/ComingSoon.js